import {elementUiPlugin} from '@/plugin/element-ui';
import {vueRouterPlugin} from '@/plugin/vue-router';

export function initPlugin(Vue) {
  elementUiPlugin(Vue);
  vueRouterPlugin(Vue);
}
